import React from 'react';
import Review from './review';
import '../css/Service.css';

function LiquidWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={'/img_4.jpg'} alt="Liquid Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Liquid Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>LIQUID WASTE</h1>
        <p>
          Clean World waste management team travels to site to collect your liquid waste and transport it to an EPA approved treatment center. With a large network of transportation and treatment facilities nationwide, we can provide services at favorable pricing.
        </p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Liquid Wastes that we dispose or recycle include:</h2>
          <ol className="feature-list">
            <li>Wastewater Disposal</li>
            <li>Used Oil and Oily Water</li>
            <li>Fats, Oils, or Greases</li>
            <li>Industrial Wastewater</li>
            <li>Organic Liquids</li>
            <li>Latex Wastewater</li>
            <li>Process Wastewater</li>
            <li>Hydraulic Fracturing Fluids</li>
            <li>Other Non-Hazardous Liquids</li>
          </ol>

          <p>
            Our drivers are trained in local, state, federal, OSHA and EPA regulations. They are experts at waste profiling, labeling, manifesting, and reporting to ensure compliant handling from pick-up to treatment.
          </p>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Liquid Waste Pickup</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Service Highlights</h3>
            <ul className="specialty-list">
              <li>On-site collection and secure transport</li>
              <li>EPA-approved treatment partners</li>
              <li>Competitive pricing through national network</li>
              <li>Complete documentation and reporting</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
}

export default LiquidWaste;
